import { slugifyEndpoint } from '@rbx/docsite-utilities/dist/browser';
import type { useTranslation } from '@rbx/intl';
import HeadingItem from '@modules/utilities/interfaces/HeadingItem';
import OpenCloudAPIContent from '../../../utils/interfaces/OpenCloudAPIContent';
import { endpointsID, objectsID } from '../constants/openCloudConstants';

export default function deriveHeadings(
  translate: ReturnType<typeof useTranslation>['translate'],
  { endpoints, objects }: OpenCloudAPIContent,
): HeadingItem[] {
  const headings: HeadingItem[] = [];

  endpoints.forEach(({ category, paths }) => {
    headings.push({ title: category, slug: `${endpointsID}-${category}`, level: 2 });

    headings.push(
      ...paths.flatMap(({ path, operations }) =>
        operations.map(({ name, method }) => ({
          title: name,
          label: method,
          slug: slugifyEndpoint(path, method),
          level: 3,
        })),
      ),
    );
  });

  // "objects" section
  if (objects.length > 0) {
    headings.push({ title: translate('Label.Objects'), slug: objectsID, level: 2 });
  }

  headings.push(
    ...objects.map(({ name, title }) => ({
      title: title ?? name,
      slug: name.replace(/\s+/g, '_'),
      level: 3,
    })),
  );

  return headings;
}
